import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCategory } from "./actions";

export const categoryEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.name,
});

const initialState = categoryEntityAdapter.getInitialState({});

export const categorySlice = createSlice({
  name: "category",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCategory.fulfilled, (state, action) => {
      if (action.payload.success) {
        categoryEntityAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

export default categorySlice.reducer;
